export default function getRandomCreators(creators, number) {
  const items = Array.from(creators);
  return items.sort(() => 0.5 - Math.random()).slice(0, number);
}
